import React from "react";
import { useLanguage } from "../context/LanguageContext";

export const Features = (props) => {
  const { language } = useLanguage();

  const titles = {
    en: { label: "Why Choose Us", title: "Built for Success", subtitle: "We combine technical expertise with a commitment to your success" },
    hi: { label: "हमें क्यों चुनें", title: "सफलता के लिए निर्मित", subtitle: "हम तकनीकी विशेषज्ञता को आपकी सफलता के प्रति प्रतिबद्धता के साथ जोड़ते हैं" },
    pa: { label: "ਸਾਨੂੰ ਕਿਉਂ ਚੁਣੋ", title: "ਸਫਲਤਾ ਲਈ ਬਣਾਇਆ", subtitle: "ਅਸੀਂ ਤਕਨੀਕੀ ਮੁਹਾਰਤ ਨੂੰ ਤੁਹਾਡੀ ਸਫਲਤਾ ਪ੍ਰਤੀ ਵਚਨਬੱਧਤਾ ਨਾਲ ਜੋੜਦੇ ਹਾਂ" },
    fr: { label: "Pourquoi Nous Choisir", title: "Conçu pour le Succès", subtitle: "Nous combinons expertise technique et engagement envers votre réussite" }
  };

  const features = {
    en: [
      { icon: "🚀", title: "Fast Delivery", text: "Agile development ensures quick turnaround without compromising quality" },
      { icon: "🛡️", title: "Secure & Reliable", text: "Enterprise-grade security and 99.9% uptime guarantee" },
      { icon: "👥", title: "Dedicated Team", text: "A team of experts committed to your project's success" },
      { icon: "🔄", title: "Ongoing Support", text: "24/7 support and maintenance to keep your software running" }
    ],
    hi: [
      { icon: "🚀", title: "तेज़ डिलीवरी", text: "एजाइल डेवलपमेंट गुणवत्ता से समझौता किए बिना त्वरित परिणाम सुनिश्चित करता है" },
      { icon: "🛡️", title: "सुरक्षित और विश्वसनीय", text: "एंटरप्राइज़-ग्रेड सुरक्षा और 99.9% अपटाइम गारंटी" },
      { icon: "👥", title: "समर्पित टीम", text: "आपके प्रोजेक्ट की सफलता के लिए प्रतिबद्ध विशेषज्ञों की टीम" },
      { icon: "🔄", title: "निरंतर सहायता", text: "आपके सॉफ्टवेयर को चलाने के लिए 24/7 सहायता और रखरखाव" }
    ],
    pa: [
      { icon: "🚀", title: "ਤੇਜ਼ ਡਿਲੀਵਰੀ", text: "ਐਜਾਇਲ ਡਿਵੈਲਪਮੈਂਟ ਗੁਣਵੱਤਾ ਨਾਲ ਸਮਝੌਤਾ ਕੀਤੇ ਬਿਨਾਂ ਤੇਜ਼ ਨਤੀਜੇ ਯਕੀਨੀ ਬਣਾਉਂਦੀ ਹੈ" },
      { icon: "🛡️", title: "ਸੁਰੱਖਿਅਤ ਅਤੇ ਭਰੋਸੇਮੰਦ", text: "ਐਂਟਰਪ੍ਰਾਈਜ਼-ਗ੍ਰੇਡ ਸੁਰੱਖਿਆ ਅਤੇ 99.9% ਅਪਟਾਈਮ ਗਾਰੰਟੀ" },
      { icon: "👥", title: "ਸਮਰਪਿਤ ਟੀਮ", text: "ਤੁਹਾਡੇ ਪ੍ਰੋਜੈਕਟ ਦੀ ਸਫਲਤਾ ਲਈ ਪ੍ਰਤੀਬੱਧ ਮਾਹਰਾਂ ਦੀ ਟੀਮ" },
      { icon: "🔄", title: "ਨਿਰੰਤਰ ਸਹਾਇਤਾ", text: "ਤੁਹਾਡੇ ਸਾਫਟਵੇਅਰ ਨੂੰ ਚਲਾਉਣ ਲਈ 24/7 ਸਹਾਇਤਾ ਅਤੇ ਰੱਖ-ਰਖਾਅ" }
    ],
    fr: [
      { icon: "🚀", title: "Livraison Rapide", text: "Le développement agile assure un retour rapide sans compromettre la qualité" },
      { icon: "🛡️", title: "Sécurisé et Fiable", text: "Sécurité de niveau entreprise et garantie de disponibilité de 99.9%" },
      { icon: "👥", title: "Équipe Dédiée", text: "Une équipe d'experts engagée dans le succès de votre projet" },
      { icon: "🔄", title: "Support Continu", text: "Support et maintenance 24/7 pour garder votre logiciel opérationnel" }
    ]
  };

  const t = titles[language] || titles.en;
  const featureList = features[language] || features.en;

  return (
    <section id="features">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{t.label}</span>
          <h2 className="section-title">{t.title}</h2>
          <p className="section-description">
            {t.subtitle}
          </p>
        </div>
        <div className="features-grid">
          {featureList.map((feature, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
